/**
 * Tailwind CSS implementation of Image component
 * Uses Seeds image CSS classes from image.css
 */

import React from "react";

// Utility for merging class names properly
function cn(
  ...inputs: (string | undefined | null | false | Record<string, boolean>)[]
): string {
  const classes: string[] = [];

  for (const input of inputs) {
    if (!input) continue;

    if (typeof input === "string") {
      classes.push(input);
    } else if (typeof input === "object") {
      for (const [key, value] of Object.entries(input)) {
        if (value) {
          classes.push(key);
        }
      }
    }
  }

  return classes.join(" ");
}

type TypeImageTailwindProps = React.ComponentPropsWithoutRef<"img"> & {
  isLoading?: boolean;
};

export const ImageTailwind = React.forwardRef<
  HTMLImageElement,
  TypeImageTailwindProps
>(({ isLoading, className, ...rest }, ref) => (
  <img
    ref={ref}
    // Preserve the legacy "Image" marker class (set by styles.ts's .attrs)
    // for any consumer selectors targeting it.
    className={cn(
      "Image",
      "seeds-image",
      { "seeds-image-loading": !!isLoading },
      className
    )}
    {...rest}
  />
));

ImageTailwind.displayName = "ImageTailwind";
